import { useSelector } from 'react-redux';

import { type CurrenciesKey } from "src/core/config/money";
import { getCompanyCurrency } from "src/core/selectors/globalSelectors";

export const useCompanyCurrency = <T extends CurrenciesKey = CurrenciesKey>() =>
  useSelector(getCompanyCurrency) as T;
